import { useEffect, useRef } from 'react';

export const useHeadingRefocus = (heading_ref) => {
  const last = useRef(null);

  // No deps: every render may be the one that removed the focused control.
  useEffect(() => {
    const el = last.current;
    if (!el || el.isConnected) return;
    last.current = null;
    // Focus the operator already moved somewhere real is left alone.
    const active = document.activeElement;
    if (active && active !== document.body) return;
    if (heading_ref.current) heading_ref.current.focus({ preventScroll: true });
  });

  return (e) => {
    last.current = e.target;
  };
};
